<template>
  <div class="job-detail-page container">
    <!-- 岗位信息 -->
    <div class="job-info">
      <div class="top fb">
        <span class="job-name">跨境物流销售</span>
        <span class="wages">底薪+提成</span>
      </div>
      <div class="city">宁波,苏州,大连,合肥,成都,深圳,嘉兴,郑州,杭州</div>
      <div class="bottom fb">
        <span class="require">招聘5人 ｜&nbsp;&nbsp;不限&nbsp;&nbsp;｜ 1-3年工作经验</span>
      </div>
    </div>
    <!-- 岗位详情 -->
    <div class="job-content">
      <div class="job-detail">
        <div class="info-title">工作职责</div>
        <p>1.合理利用公司平台资源，开发拓展新客户； 2.定期拜访客户，与同行客户保持常态性的交流沟通，了解客户的实际需求； 3.通过与客户的沟通了解与掌握市场行情及相关信息，及时向产品（航线）部门进行反馈； 4.根据客户需求制定相应的物流方案并报价，推广公司优势产品和服务； 5.协调处理业务推进过程中出现的爆舱改配、补货、甩箱、加载、重箱出卡等各类突发情况； 6.协助结算人员对应收未收款进行催收，完成业务回款； 7.其他工作。</p>
      </div>
      <div class="job-detail">
        <div class="info-title">职位要求：</div>
        <p>1.优秀的沟通及销售技能，表达能力强，高度的责任心及抗压能力； 2.具备一定的市场分析及判断能力，良好的客户服务意识； 3.2年以上物流销售经验，有一定的行业资源； 4.热爱销售，具有自信心，心态乐观，不满足于现状,有责任心，能承受较大的工作压力。</p>
      </div>
    </div>
    <div class="apply-email">
      简历投递邮箱：<span>info@hstocean.com</span>
    </div>
    <!-- 提交表单 -->
    <div class="submit-form" v-if="false">
      <div class="title">申请职位</div>
      <a-form
        :model="formState"
        name="basic"
        autocomplete="off"
      >
        <a-form-item
          label="姓名"
          name="username"
          :rules="[{ required: true, message: '请输入' }]"
        >
          <a-input v-model:value="formState.username" placeholder="请输入" />
        </a-form-item>

        <a-form-item
          label="手机号码"
          name="phone"
          :rules="[{ required: true, message: '请输入' }]"
        >
          <a-input v-model:value="formState.phone" placeholder="请输入" />
        </a-form-item>

        <a-form-item
          label="短信验证码"
          name="phone"
          class="verifiCode-item"
          :rules="[{ required: true, message: '请输入' }]"
        >
          <a-input v-model:value="formState.phone" placeholder="请输入" />
          <a-button>获取验证码</a-button>
        </a-form-item>

        <a-form-item
          label="文件上传"
          name="file"
          class="verifiCode-item"
          :rules="[{ required: true, message: '请上传' }]"
        >
          <a-upload
            v-model:file-list="fileList"
            :showUploadList="false"
            name="file"
            :maxCount="1"
            @change="handleChange"
          >
            <a-input v-model:value="formState.file" readonly placeholder="请上传" />
            <a-button>选择</a-button>
          </a-upload>
        </a-form-item>
        <a-button  class="submit-btn" type="primary">递交申请</a-button>
      </a-form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
const formState = ref({});
const handleChange = (value) => {
  const { file } = value;
  formState.value.file = file?.name;
}
</script>

<style lang="less" scoped>
.job-detail-page {
  width: 100%;
  margin-top: 97px;
  .job-info {
    padding: 34px 37px;
    box-shadow: 0px 4px 23.9px 0px rgba(184, 184, 184, 0.25);
    line-height: 20px;
    .top {
      font-size: 20px;
      .job-name {
        color: #151E2C;
      }

      .wages {
        color: #158AFF;
        font-weight: 500;
      }
    }

    .city {
      font-size: 16px;
      color: #959595;
      margin-top: 12px;
      margin-bottom: 39px;
    }

    .bottom {
      color: #959595;
      font-size: 16px;
    }
  }
  .job-content {
    padding: 30px 0;
    .job-detail {
      margin-bottom: 41px;
      &:last-child {
        margin-bottom: 0;
      }
      .info-title {
        font-size: 14px;
        color: #000;
        line-height: 20px;
        margin-bottom: 13px;
      }
      p {
        font-size: 12px;
        color: #8F8F8F;
        line-height: 20px;
      }
    }
  }
  .apply-email {
    margin-top: 44px;
    span {
      color: rgba(48, 113, 255, 1);
    }
    margin-bottom: 264px;
  }
  .submit-form {
    background: #F8F9FB;
    margin-top: 76px;
    margin-bottom: 264px;
    padding: 29px 0 31px 0;
    .title {
      color: #000;
      font-size: 18px;
      text-align: center;
      margin-bottom: 45px;
    }
    .ant-form {
      max-width: 712px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      column-gap: 49px;
      /deep/ .ant-form-item {
        width: calc(50% - 24.5px);
        margin-bottom: 37px;

        &.verifiCode-item {
          .ant-form-item-control .ant-form-item-control-input-content {
            display: flex;
            justify-content: space-between;
            gap: 11px;
          }
        }
        .ant-upload-wrapper {
          .ant-upload {
            display: flex;
            justify-content: flex-start;
            gap: 11px;
          }
          .ant-btn {
            width: 84px;
          }
        }
        .ant-btn  {
          flex: 0 0 84px;
          height: 42px;
          border-radius: 4px;
          border: 1px solid #D2D2D2;
          color: #797979;
          font-size: 14px;
          padding: 0;
        }

        .ant-form-item-label {
          // width: 84px;
          flex: 1;
          text-align: left;
          line-height: 42px;
          label {
            color: #25262C;
            font-size: 14px;
          }
        }
        .ant-form-item-control  {
          flex: 0 0 230px;
        }
        .ant-input {
          height: 42px;
          line-height: 42px;
          border-radius: 4px;
          background-color: #fff;
          cursor: pointer;
          border: 1px solid #DBDBDB;
        }
      }
    }

    .submit-btn {
      flex: 0 0 100%;
      height: 50px;
      background: #3071FF;
      font-size: 14px;
      font-weight: 500;
      margin-top: 17px;
    }
  }
}
</style>